import React from 'react'
import delve from 'dlv'
import { formatDate } from 'services/helpers'
import { Text } from 'components/typo'
import classnames from 'classnames/bind'
import Link from 'src/components/shared/Link'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const TimelineEntry = ({
  className,
  firstElement,
  version,
  date,
  title,
  summary,
  redirectLink,
}) => {
  const redirect = delve(redirectLink, 'link', null)
  const formattedDate = formatDate(date, { month: 'short' })
  const Wrapper = redirect && redirect.href ? Link : 'div'

  return (
    <Wrapper className={cx(className, css.TimelineEntry)} {...redirect}>
      <div className={cx(css.timeline)}>
        <div className={cx(css.line, { firstElement })} />
      </div>
      <div className={css.textContent}>
        <div className={css.head}>
          {date && (
            <Text className={css.label} size="smaller">
              {formattedDate}
            </Text>
          )}
          {version && (
            <Text className={css.label} size="smaller">
              {version}
            </Text>
          )}
        </div>
        <Text size="small" theme="dark" className={css.title}>
          {title}
        </Text>
        <Text size="smaller">{summary}</Text>
      </div>
    </Wrapper>
  )
}

TimelineEntry.defaultProps = {}

export default TimelineEntry
